import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminCatering() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/catering").then(({data}) => setItems(data)).catch(() => {}); }, []);
  return (
    <div data-testid="admin-catering">
      <h1 className="font-heading text-3xl text-[#FAF9F6] mb-5">Catering Requests</h1>
      <div className="grid md:grid-cols-2 gap-4">
        {items.map(c => (
          <div key={c.id} className="admin-card p-5">
            <div className="flex justify-between mb-2">
              <span className="badge-royal">{c.event_type.toUpperCase()}</span>
              <span className="text-xs text-[#FAF9F6]/60">{new Date(c.created_at).toLocaleDateString()}</span>
            </div>
            <h3 className="font-heading text-xl text-[#D4AF37]">{c.customer_name}</h3>
            <div className="text-xs text-[#FAF9F6]/70 mb-2">{c.customer_phone} · {c.customer_email}</div>
            <div className="text-sm text-[#FAF9F6]">{c.guests} guests · {c.event_date} {c.event_time}</div>
            {c.notes && <p className="text-xs italic text-[#FAF9F6]/60 mt-2">"{c.notes}"</p>}
            {c.selected_trays?.length > 0 && (
              <ul className="text-xs text-[#FAF9F6]/70 mt-2">
                {c.selected_trays.map((t, i) => <li key={i}>{t.qty}× {t.name} · ${t.price}</li>)}
              </ul>
            )}
            <div className="text-xs text-[#D4AF37] mt-2 font-accent">{c.status}</div>
          </div>
        ))}
        {items.length === 0 && <p className="text-[#FAF9F6]/40">No catering requests</p>}
      </div>
    </div>
  );
}
